import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaHome } from 'react-icons/fa';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconContainer}>
          <FaExclamationTriangle style={styles.icon} />
        </div>
        <h1 style={styles.title}>404</h1>
        <h2 style={styles.subtitle}>Page Not Found</h2>
        <p style={styles.description}>
          Oops! The page you are looking for doesn't exist, has been removed, or has had its name changed.
        </p>
        <button
          onClick={() => navigate('/')}
          style={styles.button}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.3)';
            e.currentTarget.style.filter = 'brightness(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 14px rgba(59, 130, 246, 0.2)';
            e.currentTarget.style.filter = 'brightness(1)';
          }}
        >
          <FaHome style={{ marginRight: '8px' }} /> Back to Home
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: '24px',
    background: 'transparent',
    fontFamily: "'Outfit', 'Inter', -apple-system, sans-serif",
  },
  card: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '24px',
    padding: '48px 32px',
    textAlign: 'center',
    maxWidth: '480px',
    width: '100%',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.02)',
  },
  iconContainer: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'rgba(239, 68, 68, 0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  icon: {
    fontSize: '36px',
    color: '#ef4444',
  },
  title: {
    fontSize: '6rem',
    fontWeight: '900',
    margin: '0',
    lineHeight: '1',
    background: 'linear-gradient(135deg, #4f46e5, #3b82f6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: {
    fontSize: '1.8rem',
    fontWeight: '800',
    color: '#1e293b',
    margin: '12px 0 16px',
    letterSpacing: '-0.5px',
  },
  description: {
    fontSize: '1rem',
    color: '#64748b',
    lineHeight: '1.6',
    margin: '0 auto 32px',
    maxWidth: '360px',
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 28px',
    background: 'linear-gradient(135deg, #4f46e5, #3b82f6)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '30px',
    fontSize: '0.95rem',
    fontWeight: '700',
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(59, 130, 246, 0.2)',
    transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
    outline: 'none',
  },
};

export default NotFound;
